import { render, staticRenderFns } from "./ViewPostPrivateLabel.vue?vue&type=template&id=41821c8e&"
import script from "./ViewPostPrivateLabel.vue?vue&type=script&lang=js&"
export * from "./ViewPostPrivateLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports